export default {"src":"/_next/static/media/bulb.0e18df7a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};